module.exports = "https://static.wmbcdn.com/uniweb/images/2a07411b7c8c215146844820df32ea3d.svg";